import React from 'react';
import { NavLink } from 'react-router-dom';

const AddClientCrumb = () => <NavLink to="/core/clients/add">Add Client</NavLink>;

export default AddClientCrumb;
